export const THUMBNAIL_PLACEHOLDER: string =
  'https://firebasestorage.googleapis.com/v0/b/faro-dev-d2099.appspot.com/o/images%2Fthumbnail%2Fthumbnail-placeholder.png?alt=media&token=97df4694-81fd-4661-8657-944d3ebb0a3e';
export const FULL_SIZE_PLACEHOLDER: string =
  'https://firebasestorage.googleapis.com/v0/b/faro-dev-d2099.appspot.com/o/images%2Fimages_full_size%2Fimage-full-size-placeholder.png?alt=media&token=0f4f2d7b-e052-48e2-bfa3-4bf5f71725dc';
export const FILE_ICON_PLACEHOLDER: string =
  'https://firebasestorage.googleapis.com/v0/b/faro-dev-d2099.appspot.com/o/documents%2Ffile-icon.png?alt=media&token=eb3aac6f-5acb-4ae0-ad0e-7ea94562c6ea';
export const EXCEL_TEMPLATE: string =
  'https://firebasestorage.googleapis.com/v0/b/quick-pass-prod.appspot.com/o/template%2FTemplateCargaMasiva.xlsx?alt=media&token=0685e2d2-b42c-4d92-94c2-30cbfd806d55';

// Roles en el origen de venta para tickets y estadisticas
export const TICKET_ROL_ORIGIN = {
  PRODUCER: 'producer',
  PRODUCER_BO: 'producer-bo',
  RRPPSELL: 'rrppsell',
  GIFT_BO: 'gift-bo',
  LOYALY: 'loyaly',
  STANDAR: 'standard'
};

export const COLORS_CTG = Object.freeze({
  PRODUCER: { initial: 'D', color: 'rgb(0, 0, 0)' },
  PRODUCER_BO: { initial: 'D', color: 'rgb(0, 0, 0)' },
  RRPPSELL: { initial: 'D', color: 'rgb(0, 0, 0)' },
  GIFT_BO: { initial: 'I', color: 'rgb(255, 165, 0)' },
  LOYALTY: { initial: 'C', color: 'rgb(176, 168, 13)' },
  STANDAR: null // No muestra inicial-avatar
});

//Codigos de error y advertencia en la creacion de tickets
export const TICKET_CREATION_CODES = {
  100: 'Missing ID',
  101: 'ID contains invalid characters',
  102: 'ID exceeds 12 characters',
  103: 'ID does not match the expected format',
  104: 'Invalid quantity (less or equal to 0)',
  105: 'Non-numeric or too big quantity',
  106: 'Missing or decimal quantity',
  200: 'Row grouped to another existing row(same ID and email)',
  201: 'The customer exceeds the number of tickets allowed per person',
  202: 'Row grouped to another existing row(same ID and email) and maximum quantity exceeded',
};


// ERRORES DE FIREASE
export const FIREBASE_ERRORS = {
  INVALID_EMAIL: 'auth/invalid-email',
  USER_DISABLED: 'auth/user-disabled',
  USER_NOT_FOUND: 'auth/user-not-found',
  WRONG_PASSWORD: 'auth/wrong-password'
};

export const PERMISSIONS_ROL_RRPP = [
  {
    description: 'Líder de RRPP',
    key: 'proRrrpLeader'
  },
  {
    description: 'Eliminar tickets RRPP',
    key: 'rrppTicketDelete'
  }
];
